// Formats numbers using Indian digit grouping (lakh/crore), e.g. 10000000 -> "1,00,00,000"
export function formatIndianNumber(value: number | string, decimals = 0): string {
    const num = Number(value) || 0;
    return num.toLocaleString("en-IN", {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
    });
}

// Formats a value as Indian currency with the ₹ symbol, e.g. 10000000 -> "₹1,00,00,000.00"
export function formatIndianCurrency(value: number | string, decimals = 2): string {
    return `₹${formatIndianNumber(value, decimals)}`;
}
